import React from 'react';
import './Loading.css';

function Loading() {
  return (
    <div className="sbd-loading" role="status" aria-live="polite" aria-label="Loading">
      <svg className="sbd-loading-spinner" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect className="sbd-loading-sq sbd-loading-sq-1"
              x="2" y="2" width="32" height="32" rx="3"
              strokeWidth="2.5" strokeLinecap="round" />
        <rect className="sbd-loading-sq sbd-loading-sq-2"
              x="22" y="22" width="32" height="32" rx="3"
              strokeWidth="2.5" strokeLinecap="round" />
        <path className="sbd-loading-play" d="M26 23.5 L26 32.5 L33 28 Z" />
      </svg>
    </div>
  );
}

export default Loading;
